import { api } from '../../Controllers/api'

const requestHauls = () => {
  return {
    type: 'REQUEST_HAULS',
    loading: true
  }
}

const receiveHauls = data => {
  return {
    type: 'RECEIVE_HAULS',
    payload: { data },
    loading: false
  }
}

const addHaul = data => {
  return {
    type: 'ADD_HAUL',
    payload: { data }
  }
}

const editedHaul = data => {
  return {
    type: 'EDIT_HAUL',
    payload: { data }
  }
}

const getHauls = isRefresh => {
  return dispatch => {
    if (!isRefresh) {
      dispatch(requestHauls())
    }
    api.get(`hauls`).then(({ data }) => {
      dispatch(receiveHauls(data))
    })
  }
}

const createNewHaul = haul => {
  const { _id } = haul.project
  const newHaul = { ...haul }
  return dispatch => {
    api.post(`hauls/${_id}`, newHaul).then(data => {
      dispatch(addHaul({ ...newHaul, _id: data.insertedId }))
    })
  }
}

const editHaul = haul => {
  const { _id } = haul
  const payload = { ...haul, _id: undefined }
  return dispatch => {
    api.put(`hauls/${_id}`, payload).then(({ data }) => {
      dispatch(editedHaul(haul))
    })
  }
}

export { getHauls, createNewHaul, editHaul }
